export enum Breakpoints {
  mobile = 480,
  tablet = 768,
  laptop = 1024,
  desktop = 1280,
  wide = 1536,
  ultrawide = 1920,
}

export const breakpoints = {
  mobile: Breakpoints.mobile,
  tablet: Breakpoints.tablet,
  laptop: Breakpoints.laptop,
  desktop: Breakpoints.desktop,
  wide: Breakpoints.wide,
  ultrawide: Breakpoints.ultrawide,
} as const;
